import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Dropdown from "./Dropdown";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import "../scss/navbar.scss";

const links = [
  {
    name: "Démarrer un projet",
    link: "/newproject",
  },
  {
    name: "Actualités",
    link: "/news",
  },
  {
    name: "Nos prestations",
    link: "/prestations",
  },
  {
    name: "A propos",
    menu: [
      {
        name: "L'histoire",
        link: "/history",
      },
      {
        name: "L'entreprise",
        link: "/company",
      },
    ],
  },
  {
    name: "Contact",
    link: "/contact",
  },
];

const NavItem = ({ link, onClick, onEnter, onLeave, children, Icon }) => {
  return (
    <li
      onMouseEnter={onEnter ? onEnter : null}
      onMouseLeave={onLeave ? onLeave : null}
    >
      <NavLink
        key={link.name}
        className="navbar-link"
        activeClassName="navbar-link-active"
        to={link.link}
        onClick={onClick}
      >
        {link.name} {Icon}
      </NavLink>
      {children}
    </li>
  );
};

const NavBarTest = () => {
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const handleOpen = () => setOpen(!open);
  const closeMobileMenu = () => setOpen(false);

  const mobileClick = () =>
    window.innerWidth <= 900 ? setDropdown(!dropdown) : null;

  const onMouseEnter = () =>
    window.innerWidth >= 900 ? setDropdown(true) : null;

  const onMouseLeave = () =>
    window.innerWidth >= 900 ? setDropdown(false) : null;

  const navLinks = links.map((link) =>
    link.menu ? (
      <li
        key={link.name}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={mobileClick}
      >
        <p className="navbar-link">
          {link.name} {<ArrowDropDownIcon />}
        </p>
        {dropdown && (
          <Dropdown menu={link.menu} navOpen={open} onClick={closeMobileMenu} />
        )}
      </li>
    ) : (
      <NavItem key={link.name} link={link} onClick={closeMobileMenu} />
    )
  );

  return (
    <div className="navbar">
      <Link to="/" className="brand" onClick={closeMobileMenu}></Link>
      <div className="mobile-menu-icon" onClick={handleOpen}>
        {open ? <CloseIcon /> : <MenuIcon />}
      </div>
      <ul className={`navbar-links ${open ? " open" : ""}`}>{navLinks}</ul>
    </div>
  );
};

export default NavBarTest;
